(function () {
    // Desktop menu only: wrapping the mobile drawer's submenus breaks Buddha's own sizing.
    const MENU_ITEM_SELECTOR = '.horizontal-mega-menu li.buddha-menu-item';
    const OBSERVER_LIFETIME_MS = 10000;

    function wrapSubmenu(item) {
        const subMenu = item.querySelector('.mm-submenu');
        if (!subMenu) return;

        if (subMenu.parentElement && subMenu.parentElement.classList.contains('mm-submenu-wrapper')) {
            item.classList.add('nav-item-processed');
            return;
        }

        const subMenuWrapper = document.createElement('div');
        subMenuWrapper.classList.add('mm-submenu-wrapper');
        subMenu.parentNode.insertBefore(subMenuWrapper, subMenu);
        subMenuWrapper.appendChild(subMenu);
        item.classList.add('nav-item-processed');
    }

    function processAll(root) {
        root.querySelectorAll(MENU_ITEM_SELECTOR).forEach(wrapSubmenu);
    }

    document.addEventListener('DOMContentLoaded', function () {
        processAll(document);

        const menuRoot = document.querySelector('.horizontal-mega-menu') || document.body;
        if (!menuRoot) return;
        const observer = new MutationObserver(function (mutations) {
            const hasAddedNodes = mutations.some(function (mutation) {
                return mutation.addedNodes && mutation.addedNodes.length > 0;
            });

            if (!hasAddedNodes) return;
            requestAnimationFrame(function () {
                processAll(menuRoot);
            });
        });

        observer.observe(menuRoot, { childList: true, subtree: true });

        setTimeout(function () {
            observer.disconnect();
        }, OBSERVER_LIFETIME_MS);
    });
})();